import LocationImportTemplate from '../../../components/5templates/LocationImportTemplate'
import DataImportFormTabs from '../../../components/3modules/DataImportFormTabs'
import {useNavigate, useParams} from 'react-router-dom'

const ApproveLocationForm = () => {
    const navigate = useNavigate()
    const id = useParams().id
    const goToPreviousPage = () => {
        navigate(`/approveClient/serviceSet/${id}`)
    }
    const goToNextPage = () => {
        navigate(`/approveClient/people/${id}`)
    }

    return(
        <DataImportFormTabs flow={'addLocation'}>
                <LocationImportTemplate goToPreviousPage={goToPreviousPage}
                                        goToNextPage={goToNextPage}
                                        disabled
                />
        </DataImportFormTabs>
    )
}

export default ApproveLocationForm
